// src/store/useSubscriptionFeatureStore.js
import { create } from "zustand";

const useSubscriptionFeatureStore = create((set) => ({
  featureCodes: [],         // e.g. ["route_management"]
  featureCodesLoaded: false,

  setFeatureCodes: (codes) =>
    set({ featureCodes: codes, featureCodesLoaded: true }),

  clearFeatureCodes: () =>
    set({ featureCodes: [], featureCodesLoaded: false }),

  // The key helper — used everywhere instead of raw array check
  hasFeature: (code) => {
    // Can't call get() here, so expose it as a selector instead
    // See usage: useSubscriptionFeatureStore(state => state.featureCodes.includes(code))
  },
}));

export default useSubscriptionFeatureStore;